import React, { useContext, useEffect, useState } from 'react';
import { OnScreenContext } from '@/components/common/HorizontalScrollMenu/OnScreenContext';
import { VisibilityContext, type publicApiType } from 'react-horizontal-scrolling-menu-7';
import Arrow from './Arrow';
import styles from '../HorizontalScrollMenu.module.scss';

type LeftArrowProps = {
  isDisabled?: boolean,
};

export const LeftArrow = ({ isDisabled }: LeftArrowProps) => {
  const visibility = useContext<publicApiType>(VisibilityContext);
  const isAdjacentItemVisible = visibility.useIsVisible('first', true);

  const isOnScreen = useContext(OnScreenContext);
  const [disabled, setDisabled] = useState(isAdjacentItemVisible);

  useEffect(() => {
    if (isOnScreen) {
      setDisabled(isAdjacentItemVisible);
    }
  }, [isOnScreen, isAdjacentItemVisible]);

  const onClick = () => visibility.scrollToItem(visibility.getPrevElement(), 'smooth', 'start');

  return (<Arrow arrowClass={styles.prevArrow} isDisabled={isDisabled || disabled} onClick={onClick} />);
};

export default LeftArrow;
